import React from 'react';
import { Edit } from 'react-admin';
import PositionRateSettingsForm from '../shared/position-rate-settings-form/PositionRateSettingsForm';
import { getTransform } from '../rateSettingsTransform';

const StateLocationTypePositionRateSettingEdit = () => {
  return (
    <Edit
      mutationMode="pessimistic"
      transform={getTransform(
        ['location_type_id', 'state_id'],
        'state_location_type_position_rate_setting',
      )}
    >
      <PositionRateSettingsForm settingsField="state_location_type_position_rate_setting" />
    </Edit>
  );
};

export default StateLocationTypePositionRateSettingEdit;
